export const STATE_INITIAL = 'INIT';
export const STATE_RESOLVED = 'RESOLVED';
export const STATE_RESOLVING = 'RESOLVING';
export const STATE_ERROR = 'ERROR';